module.exports = __webpack_public_path__ + "img/hzhb_mobile_card.693b6ac6.png";